import { isUndefined, isObject } from "lodash";

export function orderTeamMember() {
    return function(input, gameAccountType) {
        if (input === null || !isObject(input)) {
            return input;
        }

        let members = [];
        for (let idx in input) {
            if (input.hasOwnProperty(idx)) {
                members.push(input[idx]);
            }
        }

        let accountTypeDefined = gameAccountType !== null && !isUndefined(gameAccountType);

        // Sort members
        members.sort(function(memberA, memberB) {
            // Check if member a or b do have an game account
            let memberAHasGameAccount = accountTypeDefined && memberA.gameaccounts.hasOwnProperty(gameAccountType);
            let memberBHasGameAccount = accountTypeDefined && memberB.gameaccounts.hasOwnProperty(gameAccountType);

            if (memberAHasGameAccount && !memberBHasGameAccount) {
                return -1;
            } else if (!memberAHasGameAccount && memberBHasGameAccount) {
                return 1;
            } else {
                // Compare names
                if (memberA.user.nickname.toLowerCase() < memberB.user.nickname.toLowerCase()) {
                    return -1;
                } else if (memberA.user.nickname.toLowerCase() > memberB.user.nickname.toLowerCase()) {
                    return 1;
                } else {
                    return 0;
                }
            }
        });

        return members;
    };
}

export function orderByTeamName() {
    return function(input) {
        if (input === null || !isObject(input)) {
            return input;
        }

        let teams = [];
        for (let idx in input) {
            if (input.hasOwnProperty(idx)) {
                teams.push(input[idx]);
            }
        }

        teams.sort(function(teamA, teamB) {
            let nameTeamA = (teamA.team.name + " " + teamA.team.suffix).toLowerCase();
            let nameTeamB = (teamB.team.name + " " + teamB.team.suffix).toLowerCase();

            if (nameTeamA < nameTeamB) {
                return -1;
            } else if (nameTeamA > nameTeamB) {
                return 1;
            } else {
                return 0;
            }
        });

        return teams;
    };
}
